module.exports = __webpack_public_path__ + "img/administrador.15444042.png";